import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import ReviewTemplateStudio from "./ReviewTemplateStudio";
import { getReviewTemplateList } from "../../helpers/backend_helper";
import "./ReviewTemplateWorkspace.scss";

export default function ReviewTemplateCreatePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { templateId } = useParams();
  const [template, setTemplate] = useState(location.state?.template || null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!templateId || template) return;
    let current = true;
    getReviewTemplateList(true).then((response) => {
      if (!current) return;
      const found = response?.data?.find((item) => Number(item.id) === Number(templateId));
      if (!response?.status || !found) setError("Review template not found.");
      else setTemplate(found);
    }).catch(() => { if (current) setError("Unable to load the review template."); });
    return () => { current = false; };
  }, [templateId, template]);
  return (
    <div className="page-content review-template-workspace-page piers-page">
      <Container fluid>
        {error ? <p role="alert">{error}</p> : templateId && !template ? <p>Loading template…</p> : <ReviewTemplateStudio
          template={template}
          onCreated={(created) => {
            setTemplate(created);
            navigate(`/system/templates/review/${created.id}/edit`, {
              replace: true,
              state: { template: created },
            });
          }}
          initialHistory={Boolean(location.state?.initialHistory)}
          closeAction={() => navigate("/system/templates")}
        />}
      </Container>
    </div>
  );
}
